(function () {
  var KEY = 'bwPopSeen';
  var params = new URLSearchParams(window.location.search);
  var posted = document.querySelector('#bw-pop-form .form__message--success, #bw-pop-form .form-status') !== null
    || params.get('customer_posted') === 'true';
  function open(el) { if (el) { el.hidden = false; document.body.style.overflow = 'hidden'; } }
  function close() {
    document.querySelectorAll('.bw-pop').forEach(function (n) { n.hidden = true; });
    document.body.style.overflow = '';
    try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
  }
  document.addEventListener('click', function (e) { if (e.target.closest('[data-bw-close]')) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  if (posted) {
    try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
    if ('scrollRestoration' in history) { history.scrollRestoration = 'manual'; }
    // Shopify posts the form to /contact#contact_form, which drops the visitor at the
    // bottom of the page. Strip the anchor and put them back where they were.
    try { history.replaceState(null, '', window.location.pathname); } catch (e) {}
    var top = function () { window.scrollTo(0, 0); };
    top();
    document.addEventListener('DOMContentLoaded', top);
    window.addEventListener('load', top);
    setTimeout(top, 60);
    open(document.getElementById('bw-pop-thanks'));
    return;
  }
  var seen = 0;
  try { seen = parseInt(localStorage.getItem(KEY) || '0', 10); } catch (e) {}
  if (seen && Date.now() - seen < 30 * 864e5) return;
  if (/\/(products|cart|checkout|challenge|account)/.test(window.location.pathname)) return;
  // Nick, 2026-09-05: never interrupt the pack builder — the popup was eating taps on the roller.
  if (document.querySelector('.bw-mach, [data-roll-b3g4], #bw-roll')) return;
  var fired = false;
  function fire() {
    if (fired) return; fired = true;
    open(document.getElementById('bw-pop'));
  }
  setTimeout(fire, 15000);
  window.addEventListener('scroll', function () {
    var d = document.documentElement;
    if ((d.scrollTop + window.innerHeight) / d.scrollHeight > 0.45) fire();
  }, { passive: true });
})();
